export interface LogIn {
    email: string;
    password: string;
}

export interface InitChangePassword {
    email: string;
}

export interface ChangePassword {
    email: string;
    code: string;
    password: string;
}
